export default __webpack_public_path__ + "static/media/Farmer Icon.f81805d4.svg";